module.exports = __webpack_public_path__ + "img/calendar-rounded.311e7040.svg";